import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import Fonts from "../../resources/fonts/Fonts";
import * as actionsService from "../../services/ActionsService/ActionsService";
import MessageModal from "../../components/UI/Modals/MessageModal/MessageModal";
import classes from "./Login.module.css";

const UnsubscribeUser = (props) => {
  let windowDimensions = {...props?.windowDimensions};
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const contentParams = urlParams.get("content")?.replaceAll(" ", "+");
  const [unsubscribeError, setUnsubscribeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(Strings.INVALID_URL)
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (contentParams) {
      actionsService
        .unsubscribeUserByContent(contentParams)
        .then((response) => {
          if (response.data.isSuccess) {
            setSuccess(response.data.isSuccess);
            setUnsubscribeError(false);
          } else {
            if (response.data.error && response.data.error.errorTitle) {
              setErrorMessage(response.data.error.errorTitle);
            }
            setUnsubscribeError(true);
          }
        })
        .catch((error) => {
            console.log(error);
        });
    }
  }, [contentParams]);

  return (
    <div className={classes.loginPage}>
      <>
        {/* Mobile version */}
        {windowDimensions.width <= 700 ? (     
          <Grid className={classes.mobileContainer} classes={{ root: classes.root }}>         
            <Grid item xs={8}>
              <div className={classes.imgContainer}>
                <div className={classes.divTest}>
                  <img
                    className={classes.image}
                    src={Icons.RESET_PASSWORD_CAR2}
                  ></img>
                  <div className={classes.title}>{Strings.LOGIN_IMAGE_TITLE}</div>
                </div>
              </div>
            </Grid>
            <Grid item xs={4} direction={"column"} justifyContent={"center"}>
              <div className={classes.formContainer}>
                <img className={classes.logoImg} src={Icons.LOGIN_LOGO}></img>
                {success && !unsubscribeError && (
                    <>
                        <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                          <h2 style={{fontFamily: Fonts.ROBOTO_BOLD}}>{Strings.SUCCESSFULY_UNSUBSCRIBED_HEADER}</h2>
                          <div style={{fontFamily: Fonts.ROBOTO_REGULAR, maxWidth: '500px'}}>{Strings.SUCCESSFULY_UNSUBSCRIBED_DESCRIPTION}</div>
                        </div>
                    </>
                )}
                {unsubscribeError && (
                  <>
                    <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                      <h2 style={{fontFamily: Fonts.ROBOTO_BOLD}}>{Strings.FAILURE_UNSUBSCRIBED_HEADER}</h2>
                      <div style={{fontFamily: Fonts.ROBOTO_REGULAR}}>{Strings.FAILURE_UNSUBSCRIBED_DESCRIPTION}</div>
                    </div>
                  </>
                )}
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid classes={{ root: classes.root }} container>
            <Grid item xs={4}>
              <div className={classes.formContainer}>
                <img className={classes.logoImg} src={Icons.LOGIN_LOGO}></img>
                {success && !unsubscribeError && (
                    <>
                        <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                          <h2 style={{fontFamily: Fonts.ROBOTO_BOLD}}>{Strings.SUCCESSFULY_UNSUBSCRIBED_HEADER}</h2>
                          <div style={{fontFamily: Fonts.ROBOTO_REGULAR, maxWidth: '500px'}}>{Strings.SUCCESSFULY_UNSUBSCRIBED_DESCRIPTION}</div>
                        </div>
                    </>
                )}
                {unsubscribeError && (
                  <>
                    <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                      <h2 style={{fontFamily: Fonts.ROBOTO_BOLD}}>{Strings.FAILURE_UNSUBSCRIBED_HEADER}</h2>
                      <div style={{fontFamily: Fonts.ROBOTO_REGULAR}}>{Strings.FAILURE_UNSUBSCRIBED_DESCRIPTION}</div>
                    </div>
                  </>
                )}
              </div>
            </Grid>
            <Grid item xs={8}>
              <div className={classes.imgContainer}>
                <div className={classes.divTest}>
                  <img
                    className={classes.image}
                    src={Icons.RESET_PASSWORD_CAR2}
                  ></img>
                  <div className={classes.title}>{Strings.LOGIN_IMAGE_TITLE}</div>
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      </>
      <MessageModal/>
    </div>
  )
}

export default UnsubscribeUser;